import {
  IonBadge,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonItemGroup,
    IonLabel,
    IonList,
    IonModal,
    IonTitle,
    IonToolbar
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { closeCircle, documentTextOutline} from 'ionicons/icons';
import { modalController } from '@ionic/core';
import './DocumentModal.css';
import ServerService from '../services/Server';
//import { Environment } from "../data/Environment";

const server = new ServerService();

interface DocumentModalProps {
    id:any;
    isOpen: any;
    onDismiss:any;
}

const DocumentModal: React.FC<DocumentModalProps> = ({id,isOpen,onDismiss}) => {

  const [open, setOpen] = useState(false)
  const [items, setItems] = useState([])

  const fetchItems = () => {
    
    const data = {id:id,doc:"1"}
    fetch(server.getFullUrl("memo/file/list", data),
        server.getRequest()
      ).then(
      response => response.json() // if the response is a JSON object
    ).then(res => {
      if (res.success) {
        console.log("success")
        setItems(res.data)
      } else {
        console.log("!success:"+res.message);
  
        if (res.message.startsWith("|BG_ERR|")) {
          //setErrMsg(res.message.substring("|BG_ERR|".length));
        } else {
          //setErrMsg(res.message);
        }
  
        //setError(true);
      }
    }).catch(
      error => {
        console.log(error) // Handle the error response object
      }
    )
  }

  useEffect(() => {
      if (open !== isOpen) {
        setOpen(isOpen)
        if (isOpen) {
          setItems([])
          fetchItems()
        }
      }
  }, [isOpen])

  return (
    <IonModal
        className="my-custom-class"
        isOpen={open}
        //swipeToClose={true}
        onDidDismiss={() => {
            onDismiss();
        }}
      >
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="end">
                <IonButton onClick={async () => {await modalController.dismiss()}}>
                    <IonIcon slot="icon-only" icon={closeCircle}/>
                </IonButton>
                </IonButtons>
                <IonTitle>{id} : Documents</IonTitle>
            </IonToolbar>
        </IonHeader>

        <IonContent>
        <IonList>
            {items?.map((item,i) => {
                var date = new Date(item.time);
                var dateStr = new Intl.DateTimeFormat("en-GB", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit"
                }).format(date)
                return (
                  <IonItemGroup key={i} onClick={e => {
//                    window.open("https://"+server.state.host+":"+server.state.port+Environment.API_PREFIX+"node/"+docRef+"/content/"+item.name+"?c=force&noCache="+new Date()+"&a=false&alf_ticket="+server.state.ticket);
                      window.open(server.getViewDocUrl(item.nodeRef, item.name))
                  }}>
                    <IonItem key={i*3} lines="none">
                        <IonIcon size="large" icon={documentTextOutline}/>
                        <IonLabel className="ion-text-wrap">{item.name}</IonLabel>
                    </IonItem>
                    <IonItem key={i*3+1} lines="none" className="doc-item">
                        <IonLabel className="ion-text-wrap doc-label">{item.desc}</IonLabel>
                    </IonItem>
                    <IonItem key={i*3+2}>
                        <IonBadge color="medium">{item.by}</IonBadge>&nbsp;
                        <IonBadge color="primary">{dateStr}</IonBadge>&nbsp;
                        <IonBadge color="success">{item.size}</IonBadge>
                    </IonItem>
                  </IonItemGroup>
                )
            })}
        </IonList>
        </IonContent>
    </IonModal>
  )
        
};

export default DocumentModal;
